import { useCallback, useState } from "react"
import classNames from "classnames"
import { IconButton } from "@oysterhr/ui"
import { QuoteItem } from "../QuoteItem"
import { HTMLDataAttributesType } from "../../types"

type QuoteCollapsableItemProps = {
  value: string | number | React.ReactElement
  label: string | React.ReactElement
  items?: React.ReactNode[]
  isCategory?: boolean
  isDeductable?: boolean
  noBorder?: boolean
  toggleDataAttributes?: HTMLDataAttributesType
} & React.HTMLAttributes<HTMLElement>

export function QuoteCollapsableItem({
  value,
  label,
  items,
  isCategory,
  isDeductable,
  noBorder,
  toggleDataAttributes,
  className,
}: QuoteCollapsableItemProps) {
  const [isCollapsed, setCollapse] = useState(true)
  const handlerClick = useCallback(() => {
    setCollapse(state => !state)
  }, [])

  const cn = classNames("text-sm transform transition", {
    "-rotate-180": !isCollapsed,
    className,
  })

  const getCollapsedDivStyle = noBorder ? "mb-2" : "rounded-md border border-gray-200 p-4 space-y-4"

  return (
    <>
      <QuoteItem
        isCategory={isCategory}
        isDeductable={isDeductable}
        value={value}
        className="items-start"
        label={
          <div className="flex items-center">
            {label}
            <IconButton
              aria-label="Collapse item"
              className={cn}
              onClick={handlerClick}
              {...toggleDataAttributes}
              iconName="ChevronDown"
              variation="borderless"
              size="sm"
            />
          </div>
        }
      />
      {!isCollapsed && <div className={getCollapsedDivStyle}>{items}</div>}
    </>
  )
}
